"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiEntity = void 0;
var services_1 = require("../services");
var mobx_1 = require("mobx");
var dayjs_1 = __importDefault(require("dayjs"));
var ApiEntity = /** @class */ (function () {
    function ApiEntity() {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // If changes have been made locally this can set to true to update your UI
        Object.defineProperty(this, "dirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // Dates
        Object.defineProperty(this, "createdDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "updatedDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(this, {
            dirty: mobx_1.observable,
        });
    }
    /**
     * Convenience function to get Api Fields for any model quickly
     */
    Object.defineProperty(ApiEntity.prototype, "getApiFields", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return services_1.getApiFields(this);
        }
    });
    __decorate([
        services_1.ApiField(),
        __metadata("design:type", Object)
    ], ApiEntity.prototype, "id", void 0);
    __decorate([
        services_1.ApiField({ creator: dayjs_1.default, serialise: false }),
        __metadata("design:type", dayjs_1.default.Dayjs)
    ], ApiEntity.prototype, "createdDate", void 0);
    __decorate([
        services_1.ApiField({ creator: dayjs_1.default, serialise: false }),
        __metadata("design:type", dayjs_1.default.Dayjs)
    ], ApiEntity.prototype, "updatedDate", void 0);
    return ApiEntity;
}());
exports.ApiEntity = ApiEntity;
//# sourceMappingURL=ApiEntity.js.map